export default __webpack_public_path__ + "static/media/SANTORINI.a55dec72.jpg";